<side-menu [activeIcon$]="props.currentLayer$" [leftMenuModelIcons]="props.leftMenuModelIcons"
  [logoText]="props.logoText" [isExpanded]="
    props?.isSideMenuVisible ? (props.isSideMenuVisible | async) : false
  " [userName]="props?.textInline ? (props.textInline | async) : undefined" (expandedChange)="toggleSideMenu($event)">
</side-menu>

<!-- <left-menu [menuItems]="props.leftMenuItems" [activeItem$]="props.currentLayer$" /> -->
<div class="map-viewer-container full-height">
  <div class="">
    <div class="icon-filter d-none d-sm-block d-md-block">
      <sit-icon *ngIf="isVisibleIcon" [icon]="Icon.respoonsive_filter" [sizeClass]="'icon-size-40 '"
        (click)="toggleFilterIncident()">
      </sit-icon>
    </div>
    <!-- <sit-map-conventions~
      [mapConventionsProperties]="props?.mapConventionsProps"
    ></sit-map-conventions> -->
    <map-filter [properties]="mapFilterModel"></map-filter>
    <!-- <ng-container *ngIf="[layers.Situations, layers.ParkingZone].includes( props.currentLayer$.value)"> -->
    <sit-map-conventions [layer]="props.currentLayer$.value"
      [mapConventionsProperties]="props?.mapConventionsProps"></sit-map-conventions>
    <!-- </ng-container> -->

    <dynamic-side-menu [properties]="dynamicMenuModel"></dynamic-side-menu>
    <div #mapboxContainer tabindex="-1" id="{{ props.containerId }}" class="mapContainer"></div>
  </div>
</div>
<sit-footer class="pos-abs" [footerMenus]="props.footerModel"></sit-footer>
